import {
  LOGIN,
  SHOW_LOADER,
  HIDE_LOADER,
  SHOW_ERROR_MESSAGE,
  HIDE_ERROR_MESSAGE,
  ADD_FLASH_MESSAGE,
  CLEAR_FLASH_MESSAGE,
  LOGOUT,
  SET_ACTIVE_CLINIC,
  SET_PATIENT_DETAILS,
  SET_APPOINTMENT_DETAILS,
  SET_APPOINTMENT_STAGE,
  CLEAR_APPOINTMENT_STATE,
  SET_APPOINTMENTS_BOOKING_MODE,
  SET_APPOINTMENTS_BOOKING_STEP,
  SET_APPOINTMENTS_BOOKING_FORM,
  SET_APPOINTMENTS_BOOKING_SPECIALTIES,
  SET_APPOINTMENTS_BOOKING_CLINICS,
  SET_APPOINTMENTS_BOOKING_PROFESSIONALS,
  SET_APPOINTMENTS_BOOKING_SUBMITTED_FILTERS,
  SET_APPOINTMENTS_BOOKING_SEARCH_RESULTS,
  SET_APPOINTMENTS_BOOKING_SEARCH_FETCHED,
  SET_APPOINTMENTS_BOOKING_SELECTED_APPOINTMENTS,
  SET_APPOINTMENTS_BOOKING_SELECTED_SPECIALTY_TAB,
  SET_APPOINTMENTS_BOOKING_SELECTED_TURN,
  ADD_APPOINTMENTS_BOOKING_CART_TURN,
  REMOVE_APPOINTMENTS_BOOKING_CART_TURN,
  CLEAR_APPOINTMENTS_BOOKING_CART,
  SET_APPOINTMENTS_BOOKING_RESULT,
  RESET_APPOINTMENTS_BOOKING_STATE
} from './actions'

/*
 * Auth
 */
export const authReducer = function(state = {}, action) {
  switch (action.type) {
    case LOGIN:
      return action.payload
    case LOGOUT:
      return {}
    default:
      return state
  }
}

/*
 * Loader
 */
export const loaderReducer = function(state = { show: false }, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return { show: true }
    case HIDE_LOADER:
      return { show: false }
    default:
      return state
  }
}

/*
 * Error Message
 */
const errorMessageDefault = {
  message: ''
}
export const errorMessageReducer = function(state = errorMessageDefault, action) {
  switch (action.type) {
    case SHOW_ERROR_MESSAGE:
      return { message: action.payload }
    case HIDE_ERROR_MESSAGE:
      return errorMessageDefault
    default:
      return state
  }
}

/*
 * Flash Message
 */
const flashMessageDefaults = {
  message: ''
}
export const flashMessageReducer = function(state = flashMessageDefaults, action) {
  switch (action.type) {
    case ADD_FLASH_MESSAGE:
      return { message: action.payload }
    case CLEAR_FLASH_MESSAGE:
      return flashMessageDefaults
    default:
      return state
  }
}

/*
 * Appointment
 */
export const createAppointmentBookingFormData = () => ({
  bookingType: 'single',
  speciality: '',
  specialities: [],
  clinic: [],
  clinicCode: [],
  professional: '',
  startDate: null,
  endDate: null,
  dateFrom: null,
  dateTo: null,
  hourFrom: null,
  hourTo: null
})

export const createAppointmentBookingState = () => ({
  mode: 'single',
  step: 0,
  formData: createAppointmentBookingFormData(),
  submittedFilters: createAppointmentBookingFormData(),
  catalogs: {
    clinics: [],
    specialties: [],
    professionals: [],
    professionalsKey: null
  },
  searchResults: [],
  searchFetched: false,
  selectedAppointments: [],
  selectedSpecialtyTab: null,
  selectedTurn: null,
  cartTurns: [],
  result: null
})

const getTurnSpecialtyKey = turn =>
  turn?.idEspecialidad ?? turn?.especialidad ?? turn?.speciality ?? null

export const appointmentDefaults = {
  activeClinic: null,
  patientDetails: null,
  appointmentDetails: null,
  appointmentStage: 0,
  booking: createAppointmentBookingState()
}

export const appointmentReducer = function(state = appointmentDefaults, action) {
  switch (action.type) {
    case SET_ACTIVE_CLINIC:
      return {
        ...state,
        activeClinic: action.payload
      }
    case SET_PATIENT_DETAILS:
      return {
        ...state,
        patientDetails: action.payload
      }
    case SET_APPOINTMENT_DETAILS:
      return {
        ...state,
        appointmentDetails: action.payload
      }
    case CLEAR_APPOINTMENT_STATE:
      return {
        ...appointmentDefaults,
        booking: createAppointmentBookingState(),
        patientDetails: state.patientDetails
      }
    case SET_APPOINTMENT_STAGE:
      return {
        ...state,
        appointmentStage: action.payload
      }
    case SET_APPOINTMENTS_BOOKING_MODE:
      return {
        ...state,
        booking: {
          ...state.booking,
          mode: action.payload,
          selectedSpecialtyTab: null
        }
      }
    case SET_APPOINTMENTS_BOOKING_STEP:
      return {
        ...state,
        booking: {
          ...state.booking,
          step: action.payload
        }
      }
    case SET_APPOINTMENTS_BOOKING_FORM:
      return {
        ...state,
        booking: {
          ...state.booking,
          formData: {
            ...state.booking.formData,
            ...action.payload
          }
        }
      }
    case SET_APPOINTMENTS_BOOKING_SPECIALTIES:
      return {
        ...state,
        booking: {
          ...state.booking,
          catalogs: {
            ...state.booking.catalogs,
            specialties: action.payload
          }
        }
      }
    case SET_APPOINTMENTS_BOOKING_CLINICS:
      return {
        ...state,
        booking: {
          ...state.booking,
          catalogs: {
            ...state.booking.catalogs,
            clinics: action.payload
          }
        }
      }
    case SET_APPOINTMENTS_BOOKING_PROFESSIONALS:
      return {
        ...state,
        booking: {
          ...state.booking,
          catalogs: {
            ...state.booking.catalogs,
            professionals: action.payload.items,
            professionalsKey: action.payload.key
          }
        }
      }
    case SET_APPOINTMENTS_BOOKING_SUBMITTED_FILTERS:
      return {
        ...state,
        booking: {
          ...state.booking,
          submittedFilters: action.payload
        }
      }
    case SET_APPOINTMENTS_BOOKING_SEARCH_RESULTS:
      return {
        ...state,
        booking: {
          ...state.booking,
          searchResults: action.payload
        }
      }
    case SET_APPOINTMENTS_BOOKING_SEARCH_FETCHED:
      return {
        ...state,
        booking: {
          ...state.booking,
          searchFetched: action.payload
        }
      }
    case SET_APPOINTMENTS_BOOKING_SELECTED_APPOINTMENTS:
      return {
        ...state,
        booking: {
          ...state.booking,
          selectedAppointments: action.payload
        }
      }
    case SET_APPOINTMENTS_BOOKING_SELECTED_SPECIALTY_TAB:
      return {
        ...state,
        booking: {
          ...state.booking,
          selectedSpecialtyTab: action.payload
        }
      }
    case SET_APPOINTMENTS_BOOKING_SELECTED_TURN:
      return {
        ...state,
        booking: {
          ...state.booking,
          selectedTurn: action.payload
        }
      }
    case ADD_APPOINTMENTS_BOOKING_CART_TURN: {
      const nextTurn = action.payload
      const nextTurnSpecialtyKey = getTurnSpecialtyKey(nextTurn)

      const nextCart = state.booking.cartTurns
        .filter(turn => {
          if (turn.idTurno === nextTurn.idTurno) return false
          if (nextTurnSpecialtyKey == null) return true
          return getTurnSpecialtyKey(turn) !== nextTurnSpecialtyKey
        })
        .concat(nextTurn)

      return {
        ...state,
        booking: {
          ...state.booking,
          cartTurns: nextCart
        }
      }
    }
    case REMOVE_APPOINTMENTS_BOOKING_CART_TURN:
      return {
        ...state,
        booking: {
          ...state.booking,
          cartTurns: state.booking.cartTurns.filter(turn => turn.idTurno !== action.payload)
        }
      }
    case CLEAR_APPOINTMENTS_BOOKING_CART:
      return {
        ...state,
        booking: {
          ...state.booking,
          cartTurns: []
        }
      }
    case SET_APPOINTMENTS_BOOKING_RESULT:
      return {
        ...state,
        booking: {
          ...state.booking,
          result: action.payload
        }
      }
    case RESET_APPOINTMENTS_BOOKING_STATE:
      return {
        ...state,
        booking: createAppointmentBookingState()
      }
    default:
      return state
  }
}
